var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBleep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1544_2181",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1544_2181",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAB6klEQVRYR+2VXShDYRjH/8pXYlcUiaSVUisutCIXNJElIleLC7VLF1wouUNIoYQVkRCJzIRFIkX5No24Eh2GfLQN+7RNR5EXcybvHBd7Lp+e8/x/7/89/3P8xOI0F3gsPx+Az4F/70D1Wi1nRlxOJyxGC26ZG5xuHkOj2obxysD5HDvAmQJPAD4q2S12zNQrcbiwzwnhFQBWlXWlv6wbl0e6byG8BsCqaia3oG6aogtgfbSiq6CVWBoaHoqsSiniUuKJ/rmWwYC8hzLAgwWtkoZPS6NFMSjtkfMHEJscB5mijABYG1zBUuc8XQdsJit6S7qIpWERAkgqchGZEPXWN+kf0VeiwP21kS4AZ64AGC8NUNaMQndwxjnulRTcMbdYVizgaPGAH4BX1fmWGWyPrdO9ArvZhvGqEWJpsCAYwtQEiKRJRN9mtr1E1mwwuYX48RVY3cSQVcivK0ZilogQUzeqXv4N7ooqQHJhCnKq8sgoDq1gqcN9FKkCZJZnQyxLIwDWh1ex2D5Hz4GvvgOBIUGIFwuRLs+Af1AAITbXPI2diQ16AJy5ejfgcrqgKGqD4ULPDwB7ctaB7+rH74CnDmhnNWAT4LA7/gbA+eSAXqcHozmBVr0HZvfEI1ZOBzza8oshH4DPAd4deAbJwhAwy3PmCwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBleep);
export default __webpack_public_path__ + "static/media/bleep.ee49f36a.svg";
export { ForwardRef as ReactComponent };